module.exports = __webpack_public_path__ + "static/media/integration-graphic.9c364acc.png";